export const menu_burger = () => (
  <path
    d="M3 12h18M3 6h18M3 18h18"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
